export enum ShipmentExportReasons {
  "Commercial" = "Commercial",
  "Gift" = "Gift",
  "Sample" = "Sample",
  "Return" = "Return",
  "Return & Repair" = "Return & Repair",
  "Personal Effects" = "Personal Effects",
  "Other" = "Other",
}
